

export default (obj) => {
    const newObj = {};
    Object.keys(obj).forEach((key) => {
        const val = obj[key];
        if (val === null || val === undefined) {
            return;
        }
        newObj[key] = val;
    });
    return newObj;
};



// WEBPACK FOOTER //
// ./src/client/utils/ignore-empty.js